import React from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoV1Img from "images/Logo-V1.png";
import LogoV1LightImg from "images/Logo-V1-light.png";
import { connect } from "react-redux";

export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
  user?: any;
}

const Logo: React.FC<LogoProps> = ({
  img = LogoV1Img,
  imgLight = LogoV1LightImg,
  className = "w-40",
  user
}) => {
  const navigate = useNavigate();
  
  const handleLogoClick = (e) => {
    e.preventDefault();
    
    if (!user) {
      navigate('/login');
    } else if (user.id && !user.company) {
      navigate('/register/thank-you');
    } else if (user.id && user.company && !user.company.is_confirmed) {
      navigate('/');
    } else {
      navigate('/');
    }
  };

  return (
    <Link
      to="/"
      onClick={handleLogoClick}
      className={`ttnc-logo inline-block text-primary-6000 focus:outline-none focus:ring-0 ${className}`}
    >
      <img
        className={`block w-56 h-auto max-h-28 ${imgLight ? "dark:hidden" : ""}`}
        src={img}
        alt="Logo"
      />
      {imgLight && (
        <img
          className="hidden w-56 h-auto max-h-28 dark:block"
          src={imgLight}
          alt="Logo-Light"
        />
      )}
      
      {/* THIS USE FOR MY CLIENT */}
      {/* PLEASE UN COMMENT BELLOW CODE AND USE IT */}
      {/* {img ? (
        <img
          className={`block max-h-12 ${imgLight ? "dark:hidden" : ""}`}
          src={img}
          alt="Logo"
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img
          className="hidden max-h-12 dark:block"
          src={imgLight}
          alt="Logo-Light"
        />
      )} */}
    </Link>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(Logo);